const namespace = "sipaApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {

  // "namespace" : {
  name: "Sipa",
  namespace,
  description: null,
  version: "1.0.0",
  /*version: "0.1.1",*/
  icon: "mdi-upload",
  accentColor: "#000080",
  mainNavEnabled: false,
  topBarEnabled: false,

  settings: {
    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 },
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },
    SipaUploadNameDEV: "SIPA Upload (Development)",
    SipaUploadNameSTG: "SIPA Upload (Staging)",

    //isAzureDeployed: true,

    appNavigation: [
      //{
        /*icon: "mdi-upload",
        text: "Sipa Upload",
        link: "SipaUpload",*/
      //}
    ],

        // SIPPA API
        environment: "DEV",
        grantType: "client_credentials",
        scope: "api://6acf06c0-97a9-47a8-8888-4193c3cbb460/Read.All",
        clientId: "6acf06c0-97a9-47a8-8888-4193c3cbb460",
        //apiUrl: "https://localhost:44339/api",
        //apiUrl: "https://sippaapi-dev.lyondellbasell.com/api",
        apiUrl: "https://api.nonprd.lyb.com/external/sippa-dev/api",
        authorizeUrl:
          "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
        redirect_uri: window.location.origin,
        logoutUrl:
          `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri==${window.location.origin}`,
        tokenUrl:
          "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",

    // rdc api
    /*environment: "DEV",
    grantType: "client_credentials",
    clientId: "6b396441-a362-4d08-8210-86ab9a8197c7",
    scope: "api://6b396441-a362-4d08-8210-86ab9a8197c7/.Read.All",
    tokenUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    authorizeUrl: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    apiUrl: "https://as-reliabilitydatacollectionapi-dev.azurewebsites.net/api",
    //apiUrl: "http://localhost:7071/api/CallValidateSIPAData",
    logoutUrl: `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
    redirect_uri: window.location.origin,
    */

  },


  parentRoute: "/sipa",
  defaultRoute: "SipaUpload",
  //accentColor: "#000080",
  childRoutes,
  component: () => import(/* webpackChunkName: "sippa" */ "@/apps/sipa/Application.vue"),
  navigation: [
    /*{
      title: "Sipa",
      route: "SipaUpload",
      icon: "mdi-upload",
    }*/
    /*{
      title: "Help",
      route: "help",
      icon: "mdi-help-circle",
    },*/
    /*{
      title: "Config",
      route: "config",
      icon: "mdi-hammer-wrench",
    },*/
  ],
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    pageTitle: {
      default: "Sipa Upload",
      storageMode: localStorage,
    },
    userDetails: {
      default: null,
      storageMode: sessionStorage,
    },
    credentialCache: {
      default: {},
      storageMode: sessionStorage,
    },
    userRoles: {
      default: [],
      storageMode: sessionStorage,
    },
    navItems: {
      default: [],
      storageMode: sessionStorage,
    },
    themeColor: {
      default: "red",
      storageMode: localStorage,
    },
    isTrue: {
      default: true,
      storageMode: sessionStorage,
    },
  }

}

export default AppConfig.merge(appConfig);


